export default __webpack_public_path__ + "static/media/artNude-3.3b48b353.jpg";